import { render, staticRenderFns } from "./groupDetail.vue?vue&type=template&id=ca838000&scoped=true&"
import script from "./groupDetail.vue?vue&type=script&lang=js&"
export * from "./groupDetail.vue?vue&type=script&lang=js&"
import style0 from "./groupDetail.vue?vue&type=style&index=0&id=ca838000&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca838000",
  null
  
)

export default component.exports